import { inject, Injectable } from '@angular/core';
import { DayJSDateFormat } from '@app/core/enums/date-format.enum';
import { DayjsLocaleService } from '@app/core/i18n/services/dayjs-locale.service';
import { CsvColumnConfig, CsvExportService } from '@app/core/services/csv-export/csv-export.service';
import { CsvExportFormattingService } from '@app/core/services/csv-export/csv-export-formatting.service';
import { ICombinedMinNoiseChartData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-min-noise/interfaces/combined-min-noise-chart-data';
import { _, TranslateService } from '@ngx-translate/core';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

@Injectable()
export class FpLoggerNoiseMinNoiseExportService {
  protected readonly csvExportService = inject(CsvExportService);
  protected readonly csvFormat = inject(CsvExportFormattingService);
  protected readonly dayjsLocale = inject(DayjsLocaleService);
  private readonly translate = inject(TranslateService);

  private getCsvColumnConfig(): CsvColumnConfig<ICombinedMinNoiseChartData>[] {
    return [
      {
        header: this.translate.instant(_('@@shared-date')),
        value: row => this.csvFormat.formatDate(row.date),
      },
      {
        header: this.translate.instant(_('@@chart-noise-level__db')),
        value: row => this.csvFormat.formatNumber(row.lowestNoiseDecibel),
      },
      {
        header: this.translate.instant(_('@@shared-status__text')),
        value: row => this.csvFormat.formatString(row.status),
      },
    ];
  }

  public exportCsv(popupMainData: ILdLogger, data: ICombinedMinNoiseChartData[]): void {
    const serialNo = popupMainData.deployment.serialNo;
    const date = popupMainData.measurement?.soundSignalStartAt;

    const formattedDate = this.dayjsLocale.dayjs(date).format(DayJSDateFormat.YYYYMMDD);

    const columns = this.getCsvColumnConfig();

    this.csvExportService.downloadCsv(`Min_Noise_History_${serialNo}_${formattedDate}.csv`, data, columns);
  }
}
